import { CARTES_BANCAIRES_VALIDATION_BIN_LENGTH } from "../../constants/configConstants";
import { compose } from "../../utils";
import { removeNonDigits, removeSpaces } from "../../utils/string";

const CARTES_BANCAIRES = "cartes_bancaires";

export const QUERY_CARD_METADATA_RESULTS = {
  valueReset: "valueReset",
  querying: "querying",
  valueUnchanged: "valueUnchanged",
};

export const isResettingSchemeChoiceValue = (queryCardMetadataResults) => {
  const { valueReset, querying } = QUERY_CARD_METADATA_RESULTS;
  return [valueReset, querying].includes(queryCardMetadataResults);
};

export const isKeepingSchemeChoiceValue = (queryCardMetadataResults) => {
  return (
    queryCardMetadataResults === QUERY_CARD_METADATA_RESULTS.valueUnchanged
  );
};

export const isCoBadgedCard = (data) => {
  return Boolean(
    data &&
      data.scheme_local === CARTES_BANCAIRES &&
      data.scheme !== data.scheme_local
  );
};

const getSchemesToDisplay = (data) => {
  if (!isCoBadgedCard(data)) {
    return [];
  }

  return [data.scheme, data.scheme_local];
};

const notifySchemeChoiceValueChanged = ({
  isDisplayed,
  schemes,
  onValueChange,
}) => {
  const newValues = {
    isDisplayed,
    schemes,
    defaultValue: CARTES_BANCAIRES,
  };

  if (onValueChange) {
    return onValueChange(newValues);
  }
};

const handleOkResponse = ({ response, state, bin, onValueChange }) => {
  state.lastResolvedBin = bin;
  state.schemes = response.data;
  const schemesToDisplay = getSchemesToDisplay(response.data);

  const isCoBadged = !!schemesToDisplay.length;

  notifySchemeChoiceValueChanged({
    isDisplayed: isCoBadged,
    schemes: schemesToDisplay,
    onValueChange,
  });
};

const isBinProcessedOrAwaitingProcessing = (state, bin) => {
  const isBinUnchanged = state.lastResolvedBin === bin;
  const isBinInFlight = state.latestInFlightBin === bin;

  return isBinUnchanged || isBinInFlight;
};

const removeResolvedBinFromInFlight = (state, resolvedBin) => {
  state.binsInFlight = state.binsInFlight.filter(
    (inFlightBin) => inFlightBin !== resolvedBin
  );
};

export const queryCardMetadataIfRequired = ({
  changedValue,
  appState,
  appUrl,
  onValueChange,
}) => {
  if (!appState.cardMetadata) {
    appState.cardMetadata = {};
  }

  const state = appState.cardMetadata;

  const cardNumber =
    changedValue && compose(removeNonDigits, removeSpaces)(changedValue);
  const isBinRequiredLength =
    cardNumber && cardNumber.length >= CARTES_BANCAIRES_VALIDATION_BIN_LENGTH;

  const hasPreviouslyQueried = !!state.lastResolvedBin;

  if (!isBinRequiredLength || !changedValue) {
    state.lastResolvedBin = undefined;
    state.latestInFlightBin = undefined;
    state.schemes = {};

    if (hasPreviouslyQueried) {
      notifySchemeChoiceValueChanged({ onValueChange, isDisplayed: false });
    }

    return QUERY_CARD_METADATA_RESULTS.valueReset;
  }

  const bin = cardNumber.substring(0, CARTES_BANCAIRES_VALIDATION_BIN_LENGTH);

  if (isBinProcessedOrAwaitingProcessing(state, bin)) {
    return QUERY_CARD_METADATA_RESULTS.valueUnchanged;
  }

  const xhttp = new XMLHttpRequest();
  xhttp.open("GET", appUrl + "/card-metadata?bin=" + bin, true);

  xhttp.onload = () => {
    const response = JSON.parse(xhttp.response);

    removeResolvedBinFromInFlight(state, bin);

    const isNewerRequestInFlight = state.latestInFlightBin !== bin;

    if (isNewerRequestInFlight) {
      return;
    }

    state.latestInFlightBin = undefined;

    if (xhttp.status === 200) {
      handleOkResponse({ response, state, bin, onValueChange });
    } else {
      if (xhttp.status === 404) {
        state.lastResolvedBin = bin;
      }
      notifySchemeChoiceValueChanged({ onValueChange, isDisplayed: false });
    }
  };

  if (!state.binsInFlight) {
    state.binsInFlight = [];
  }

  if (!state.binsInFlight.includes(bin)) {
    xhttp.send();
    state.binsInFlight.push(bin);
  }

  state.latestInFlightBin = bin;

  return QUERY_CARD_METADATA_RESULTS.querying;
};
